export default {
  lista: [],
  estaCarregando: false,
  paginaAtual: 1,
  totalItens: null,
  todosItensCarregados: false,
  funcionarioSelecionadoID: null,
  itemSelecionadoID: null,
  itemSelecionado: {
    id: null
  }
}
